



























































import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action} from 'vuex-class';
import {LoginForm} from '@/store/auth/auth.types';
import {AppResponseData} from '@/class/http';
import {Toast} from '@/store/toast/toast.types';
import {HttpService} from '@/services/api';
import VueHomeDesign1 from '@/components/layout/home-design-1.vue';


@Component({
  components: {
    HomeDesign1: VueHomeDesign1,
  }
})
export default class LoginComponent extends Vue {

  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
  @Action('_LoginMember', {namespace: 'auth'}) LoginMember!: (payload: LoginForm) => Promise<void>;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;


  public Member: LoginForm = {
    mobilePhone: '',
    password: '',
    rememberMe: false
  };
  public showpassword = true;


  async mounted() {
    if (await HttpService.Authorization()) {
      await this.$router.push('/');
    }
  }

  async authLogin() {
    let resAuth = await this.LoginMember(this.Member);
    if (Number(resAuth) === 20000) {
      this.Toast({
        heading: 'เข้าสู่ระบบสำเร็จ',
        message: 'ยินดีต้อนรับ',
        type: 'success'
      });
      await this.$router.push('/main');
    } else {
      this.Toast({
        heading: 'เข้าสู่ระบบไม่สำเร็จ',
        message: 'เกิดข้อผิดพลาดกรุณาตรวจสอบข้อมูลแล้วลองใหม่อีกครั้ง',
        type: 'danger'
      })
    }

  }

}


